/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import Backbone from 'backbone';

import GetAWPackageInformation from '../services/GetAWPackageInformation';
import CalculateAWPackageDeviceCount from '../services/CalculateAWPackageDeviceCount';
import GetAllContractExtensionTypes from '../services/GetAllContractExtensionTypes';
import AWPackageInformationView from '../views/AWPackageInformationView';
import GetAllAWPackageObjectClasses from '../services/GetAllAWPackageObjectClasses';
import GetAllAWPackageInternalOrderNumbers from '../services/GetAllAWPackageInternalOrderNumbers';
import GetAWPackageFundingCentersByFundingSourceIDAndRegionGroupID from '../services/GetAWPackageFundingCentersByFundingSourceIDAndRegionGroupID';
import GetAWPackageCostCentersByFundingCenterID from '../services/GetAWPackageCostCentersByFundingCenterID';

export default async function loadAWPackageInformationView({
  awPackageId,
  editable,
  toggleContractExtensionCheck = false,
  showValidation = false,
  isFundingSourceEditable
}) {
  const awPackage = await GetAWPackageInformation(awPackageId);

  const [deviceCount, contractExtensionTypes, objectClasses, internalOrderNumbers, fundingCenters, costCenters] =
    await Promise.all([
      CalculateAWPackageDeviceCount(awPackageId),
      GetAllContractExtensionTypes(),
      GetAllAWPackageObjectClasses(),
      GetAllAWPackageInternalOrderNumbers(),
      GetAWPackageFundingCentersByFundingSourceIDAndRegionGroupID(awPackage.fundingSourceId, awPackage.regionGroupId),
      GetAWPackageCostCentersByFundingCenterID(awPackage.fundingCenterId)
    ]);

  let toggleContractExtension = true;
  if (toggleContractExtensionCheck) {
    toggleContractExtension = awPackage.awPackageContractExtensions.length > 0 ? true : false;
  }

  awPackage.deviceCount = deviceCount;

  return new AWPackageInformationView({
    model: new Backbone.Model({
      awPackage,
      contractExtensionTypes,
      fundingCenters,
      costCenters,
      objectClasses,
      internalOrderNumbers,
      editable,
      toggleContractExtension,
      showValidation,
      isFundingSourceEditable
    })
  });
}
